module.exports = __webpack_public_path__ + "img/bg-raz-burciu.f62c81a5.jpg";